// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PlayArrow48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PlayArrow48: FC<PlayArrow48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M16 37.85v-28l22 14-22 14Zm3-5.45 13.45-8.55L19 15.3v17.1Z" />
        </svg>
    );
};

export default PlayArrow48;
